module.exports = __webpack_public_path__ + "img/map.f889f960.svg";